/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAllCountriesQueryVariables = Types.Exact<{
	[key: string]: never;
}>;

export type GetAllCountriesQuery = {
	__typename?: 'Query';
	countries: Array<{ __typename?: 'Country'; id: string; name: string }>;
};

export const GetAllCountriesDocument = gql`
	query GetAllCountries {
		countries {
			id
			name
		}
	}
`;

/**
 * __useGetAllCountriesQuery__
 *
 * To run a query within a React component, call `useGetAllCountriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllCountriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllCountriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllCountriesQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetAllCountriesQuery,
		GetAllCountriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetAllCountriesQuery, GetAllCountriesQueryVariables>(
		GetAllCountriesDocument,
		options
	);
}
export function useGetAllCountriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetAllCountriesQuery,
		GetAllCountriesQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<
		GetAllCountriesQuery,
		GetAllCountriesQueryVariables
	>(GetAllCountriesDocument, options);
}
export function useGetAllCountriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetAllCountriesQuery,
				GetAllCountriesQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<
		GetAllCountriesQuery,
		GetAllCountriesQueryVariables
	>(GetAllCountriesDocument, options);
}
export type GetAllCountriesQueryHookResult = ReturnType<
	typeof useGetAllCountriesQuery
>;
export type GetAllCountriesLazyQueryHookResult = ReturnType<
	typeof useGetAllCountriesLazyQuery
>;
export type GetAllCountriesSuspenseQueryHookResult = ReturnType<
	typeof useGetAllCountriesSuspenseQuery
>;
export type GetAllCountriesQueryResult = Apollo.QueryResult<
	GetAllCountriesQuery,
	GetAllCountriesQueryVariables
>;
